<template>
  <v-container fluid class="py-0">
    <!-- In order to see the detail of child article -->
    <v-dialog persistent v-model="dialogArticoloDettaglio" width="unset">
      <v-card>
        <v-toolbar dense class="headline indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">
            Articolo Dettaglio
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                @click="
                  closedetailModal();
                  dialogArticoloDettaglio = false;
                "
              >
                <v-icon
                  v-on="on"
                  v-bind="attrs"
                  color="error"
                  depressed
                  class=""
                  >mdi-window-close</v-icon
                >
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text
          style="max-height: 600px; overflow-y: auto; overflow-x: hidden"
          class="mt-6"
        >
          <Articolo
            :articoloId="this.recursiveId"
            :key="this.recursiveId"
            :name="this.recursiveId"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- in order to add children -->
    <v-dialog persistent v-model="dialog" width="unset">
      <v-card>
        <v-toolbar dense class="headline indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">
            Commessa Distinta Base
          </v-toolbar-title>

          <v-spacer></v-spacer>
          <Button
            classe_bottone="ml-1"
            colore_icona="success"
            idForm="COMMESSA_DISTINTA"
            idOggetto="SALVA_COMMESA_DISTINTA"
            mdi_icona="mdi-floppy"
            testo_tooltip="Salva"
            v-on:buttonClick="saveDistinta"
          />
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="hideModal" small>
                <v-icon class="" v-on="on" v-bind="attrs" color="error"
                  >mdi-window-close</v-icon
                >
              </v-btn>
            </template>
            <span>Cancallare</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col class="d-flex" cols="12" md="3">
                <v-text-field
                  type="text"
                  v-model="cod_articolo"
                  class="shrink"
                  @keydown.enter="searchDistintaBase"
                  label="Ricerca Componente"
                  placeholder="Ricerca Componente"
                  required
                ></v-text-field>
              </v-col>
              <v-col class md="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mt-5" @click="searchDistintaBase" small>
                      <v-icon
                        v-on="on"
                        v-bind="attrs"
                        color="#1a80b6"
                        size="32"
                      >
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Cerca </span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col align="center" cols="12" justify="center">
                <v-data-table
                  style="width: 100% !important"
                  :headers="headers"
                  :items="items.filter((i) => i.id_articolo != IdArticolo)"
                  class="elevation-1"
                  dense
                >
                  <!-- Colonna della quantità -->
                  <template v-slot:[`item.quantita`]="{ item }">
                    <v-text-field
                      dense
                      flat
                      hide-details
                      min="0"
                      solo
                      type="number"
                      v-model="item.quantita"
                    ></v-text-field>
                  </template>

                  <!-- Bottone delle note -->
                  <template v-slot:[`item.note`]="{ item }">
                    <v-text-field
                      background-color="white"
                      dense
                      hide-details
                      label="Note"
                      outlined
                      style="border-radius: 0px; min-width: 350px"
                      v-model="item.note"
                    ></v-text-field>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>

      <!-- Overlay di caricamento -->
      <v-overlay :value="overlay_componente" style="z-index: 10">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>
    <!-- to update single children of distinta -->
    <v-dialog
      content-class="hideoverflow"
      persistent
      v-model="dialogDistintaBase"
      width="unset"
    >
      <v-card>
        <v-toolbar dense class="headline indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">Distinta Base</v-toolbar-title>
          <v-spacer></v-spacer>
          <Button
            classe_bottone="ml-1"
            colore_icona="success"
            idForm="COMMESSA_DISTINTA"
            idOggetto="SALVA_COMMESA_DISTINTA"
            mdi_icona="mdi-floppy"
            testo_tooltip="Salva"
            v-on:buttonClick="updateDistinta"
          />
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small @click="dialogDistintaBase = false">
                <v-icon class="" v-on="on" v-bind="attrs" color="error"
                  >mdi-window-close</v-icon
                >
              </v-btn>
            </template>
            <span>Cancallare</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-subtitle>
          <v-form v-on:submit.prevent="searchDistintaBase" class="mt-n ml-n1">
            <v-container>
              <v-row>
                <v-col class="d-flex" cols="12" md="3">
                  <v-text-field
                    :disabled="this.disablesearch === true"
                    type="text"
                    v-model="cod_articolo"
                    class="shrink"
                    label="Ricerca Componente"
                    placeholder="Ricerca Componente"
                    required
                  ></v-text-field>
                </v-col>
                <v-col class md="1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mt-5" @click="searchDistintaBase" small>
                        <v-icon
                          v-on="on"
                          v-bind="attrs"
                          color="#1a80b6"
                          size="32"
                          >mdi-magnify</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Cerca </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-subtitle>
        <v-card-text style="max-height: 600px; overflow-y: auto">
          <v-container fluid>
            <v-divider></v-divider>
            <v-row>
              <v-col align="center" cols="12" justify="center">
                <v-data-table
                  :headers="headers"
                  :items="items"
                  class="elevation-1"
                >
                  <!-- Colonna della quantità -->
                  <template v-slot:[`item.quantita`]="{ item }">
                    <v-text-field
                      dense
                      flat
                      hide-details
                      min="0"
                      solo
                      type="number"
                      v-model="item.quantita"
                    ></v-text-field>
                  </template>

                  <!-- Bottone delle note -->
                  <template v-slot:[`item.note`]="{ item }">
                    <v-text-field
                      background-color="white"
                      dense
                      hide-details
                      label="Note"
                      outlined
                      style="border-radius: 0px; min-width: 350px"
                      v-model="item.note"
                    ></v-text-field>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- In order to single element -->
    <v-dialog persistent v-model="dialogEliminaDistintaBase" width="400">
      <v-card>
        <v-toolbar dense class="headline indigo lighten-1" primary-title>
          <v-toolbar-title class="white--text">
            Elimina la distinta base
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container fluid>
          <v-row>
            <v-col md="1">
              <v-icon color="error">mdi-exclamation-thick</v-icon>
            </v-col>
            <v-col>
              <p>
                Attenzione. Confermi la rimozione del componenti: N':
                {{ this.deletingQuantity }}-{{ this.deletingItemDetail }}
              </p>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row>
            <v-col md="5"></v-col>
            <v-col md="3">
              <v-btn
                dark
                tile
                class="mx-auto"
                @click="
                  deleteItem();
                  dialogEliminaDistintaBase = false;
                "
                color="green"
                >Invia</v-btn
              >
            </v-col>
            <v-col md="2">
              <v-btn
                dark
                tile
                class="mr-5"
                color="error"
                @click="dialogEliminaDistintaBase = false"
                >Anulla</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- in order to show alerts -->
    <v-snackbar
      content-class="snackbar"
      :color="color"
      right
      v-model="snackbar"
      :timeout="3000"
    >
      <v-icon :size="64">{{ mainIcon }}</v-icon>
      <h2 class="ml-16">{{ snackbar_text }}</h2>
      <v-btn
        @click="snackbar = false"
        fab
        dark
        text
        small
        style="
          margin-top: -6rem;
          float: right !important;
          margin-right: -1rem !important;
        "
      >
        <v-icon>mdi-window-close</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- Dsitinta Main  -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar dense class="indigo darken-1 rounded-t" primary-title>
            <v-toolbar-title class="white--text">
              Commessa Distinta Base
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickGestisciDistAlt"
                  small
                  v-bind="attrs"
                  v-on="on"
                  v-show="distinta_base_versione == 1"
                >
                  <v-icon color="primary"> mdi-text </v-icon>
                </v-btn>
              </template>
              <span>Distinte Base Alternative</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!on"
              @click="showIcons"
              class="ml-16"
              color="white"
              fab
              top
              tile
              small
            >
              <v-icon color="primary">mdi-arrow-collapse</v-icon>
            </v-btn>
            <v-btn
              v-if="on"
              fab
              top
              tile
              @click="hideIcons"
              class="ml-16"
              color="white"
              small
            >
              <v-icon color="primary">mdi-arrow-expand</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="text-left">
            <v-progress-circular
              class=""
              v-show="progressBar1"
              slot="progress"
              color="blue"
              indeterminate
            ></v-progress-circular>
            <v-treeview
              activatable
              shaped
              hoverable
              :open.sync="open"
              :items="distintaBaseList"
              item-key="id_treeview"
              content="6"
              open-on-click
            >
              <template v-slot:prepend="{ item, open }">
                <div>
                  <v-icon v-if="item.id == 0">{{
                    open ? "mdi-buffer" : "mdi-buffer"
                  }}</v-icon>
                  <v-icon v-if="item.id > 0">{{
                    open ? "mdi-text-short" : "mdi-text-short"
                  }}</v-icon>
                  <span v-show="item.id >= -1">
                    <template>
                      N° {{ item.quantita }} {{ item.cod_articolo }}
                    </template>
                  </span>
                </div>
              </template>

              <template v-slot:label="{ item }">
                <div>
                  {{ item.name }}
                  <span class="ml-5">
                    <b>{{ item.note }}</b>
                  </span>
                </div>
              </template>

              <template
                v-show="hideicons === true"
                slot="append"
                slot-scope="{ item }"
              >
                <v-spacer></v-spacer>
                <span v-show="item.id_rif === -1">
                  <v-btn small @click.stop="showModal">
                    <v-icon color="primary"> mdi-plus </v-icon>
                  </v-btn>
                </span>

                <!-- Bottone per il Livello Qualità Accettabile -->
                <span v-show="item.id_rif == 0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="mr-1"
                        @click="
                          $event.stopPropagation();
                          setLQA(item);
                        "
                        v-on="on"
                        small
                        :color="item.lqa === 1 ? 'success' : ''"
                      >
                        <v-icon :color="item.lqa === 1 ? 'white' : 'primary'"
                          >mdi-link-box-variant</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Tracciabilità Materia Prima</span>
                  </v-tooltip>
                </span>

                <!-- Bottone per il materiale sotto-lotto (tracciabilità lotti) -->
                <span v-show="item.id_rif == 0">
                  <v-tooltip bottom :key="key_bottone_sotto_lotto">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="mr-1"
                        @click="
                          $event.stopPropagation();
                          setMaterialeSottoLotto(item);
                        "
                        v-on="on"
                        small
                        :color="
                          item.materiale_sotto_lotto === 1 ? 'success' : ''
                        "
                      >
                        <v-icon
                          :color="
                            item.materiale_sotto_lotto === 1
                              ? 'white'
                              : 'primary'
                          "
                          >mdi-map-marker-path</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Materiale Sotto-Lotto</span>
                  </v-tooltip>
                </span>

                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="getDetail(item)"
                      v-on="on"
                      v-show="item.id_rif == 0"
                      small
                    >
                      <v-icon color="blue">mdi-text</v-icon>
                    </v-btn>
                  </template>
                  <span>Dettaglio Articolo</span>
                </v-tooltip>

                <span v-if="item.id_rif === 0">
                  <v-btn small v-on:click.stop="updateItem(item)">
                    <v-icon color="primary">mdi-pencil</v-icon>
                  </v-btn>
                </span>

                <span v-show="item.id_rif === 0">
                  <Button
                    classe_bottone="ml-1"
                    colore_icona="error"
                    idForm="COMMESSA_DISTINTA"
                    idOggetto="ELIMINA_COMMESA_DISTINTA"
                    mdi_icona="mdi-window-close"
                    testo_tooltip="Cancella Componente"
                    v-on:buttonClick="deleteFolder(item)"
                  />
                </span>
              </template>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <!-- Dialog della Distinta Base Alternativa -->
    <v-dialog v-model="distinte_alternative_visible">
      <DistintaBaseAlt
        :articolo_sel="{
          id_articolo: IdArticolo,
          cod_articolo: CompleteData.commessa[0].cod_articolo,
        }"
        @click_chiudi="chiudiGestisciDistAlt"
        :dialog_mode="true"
        :key="key_distinta_base_alt"
        @selezionata_distinta="handleSelezionataDistinta"
        :show_close="true"
      />
    </v-dialog>

    <!-- Dialog di conferma aggiunta componente ripetuto -->
    <v-dialog v-model="dialog_conferma_aggiunta_componente" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Si stanno inserendo componenti già presenti in distinta base:
            {{ (cod_componente_ripetuto + ":").replace(", :", "") }}. Confermi
            di voler procedere?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_aggiunta_componente = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn
                  @click="
                    force_aggiunta_componente = true;
                    dialog_conferma_aggiunta_componente = false;
                    saveDistinta();
                  "
                  small
                >
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma aggiunta componente nuovo con nota già presente -->
    <v-dialog v-model="dialog_conferma_aggiunta_nota" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            {{ testo_nota_ripetuta_new_componente }}
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_aggiunta_nota = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn
                  @click="
                    force_aggiunta_nota = true;
                    dialog_conferma_aggiunta_nota = false;
                    saveDistinta();
                  "
                  small
                >
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-container>
</template>
<script>
import Button from "../../../components/TOOLS/FormComponentPermissions/Button.vue";
import DistintaBaseAlt from "@/views/PRODUCTION/Articolo/ArticoloDrawer/DistintaBaseAlt.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

// import config from '../../../../public/config'
export default {
  name: "distintaBase",
  props: ["IdArticolo", "CompleteData"],
  components: {
    Button,
    Articolo: () => import("../Articolo/Articolo"),
    DistintaBaseAlt,
    SnackbarQV,
  },
  data() {
    return {
      // deleted Distinta
      cod_componente_ripetuto: "",
      distinta_base_versione: 0,
      distinte_alternative_visible: false,
      deletedDistinta: [],
      force_aggiunta_componente: false,
      force_aggiunta_nota: false,
      item: "",
      key_distinta_base_alt: 0,
      overlay: false,
      overlay_componente: false,
      progressBar: false,
      key_bottone_sotto_lotto: 0,
      // SelectedCom
      selectedcomponent: new Object(),
      progressBar1: true,
      dialogDistintaBase: false,
      ids: [],
      recursiveId: null,
      updatedDistinta: [],
      dialogArticoloDettaglio: false,
      openAll: false,
      on: true,
      findalData: [],
      deletingQuantity: 0,
      deletingItemDetail: "",
      dialog_conferma_aggiunta_componente: false,
      dialog_conferma_aggiunta_nota: false,
      dialogEliminaDistintaBase: false,
      disablesearch: false,
      open: [0],
      hideicons: true,
      quantita: 0,
      items: [],
      cod_articolo: "",
      abilita_distinta_base: 0,
      distintaBaseList: [], //array cartelle
      arrayPadre: [], //array con la lista dei nodi tra la cartella selezionata e la root
      dialog: false,
      strPath: "", //string path della cartella
      strNameFolder: "", //string nuovo nome cartella
      editIdCartella: -1, //int id cartella selezionata
      files: [],
      editedIndexAllegato: -1,
      message_new_allegato_waiting: "",
      date: new Date().toISOString().substr(0, 10),
      // Snackbar Variables
      color: "",
      snackbar: false,
      mainIcon: "",
      snackbar_text: "",
      testo_nota_ripetuta_new_componente: "",
      data: (vm) => ({
        date: new Date().toISOString().substr(0, 10),
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        menu2: false,
      }),
      headers: [
        {
          text: "Q.ta Distinta",
          value: "quantita",
          width: "150px",
        },
        {
          text: "Codice Articolo",
          value: "cod_articolo",
        },
        {
          text: "Descrizione",
          value: "des_articolo",
        },
        {
          text: "Note",
          value: "note",
          width: "100px",
        },
      ],
    };
  },
  mounted() {
    this.getModuliDrawer();
    this.blnRenameFolder = false;
    this.strNameFolder = "";
    this.files = [];
    // getting list of Distinta at initial stage
    let getdistintabase = {
      controller: "Magazzino",
      method: "POST",
      richiesta: {
        action: "getarticolidistintabase",
        token: localStorage.getItem("user_token"),
        id_articolo: this.IdArticolo,
      },
    };
    this.$store.dispatch("api", getdistintabase).then((res) => {
      this.progressBar1 = false;
      this.distintaBaseList = res.data;
      if (this.distintaBaseList.length > 0) {
        this.distintaBaseList[0].children = [];
        this.progressBar1 = false;
        if (this.CompleteData.commessa_distinta !== []) {
          this.distintaBaseList[0].children =
            this.CompleteData.commessa_distinta;
        }
      } else {
        this.distintaBaseList.push({ children: [] });
        if (this.CompleteData.commessa_distinta !== []) {
          this.distintaBaseList[0].children =
            this.CompleteData.commessa_distinta;
        }
      }

      this.getIdsForTreeview([this.distintaBaseList[0]]);
      this.open = this.ids;
    });
  },
  methods: {
    getIdsForTreeview(arg) {
      arg.forEach((e) => {
        e.id_treeview = e.id_commessa_distinta_base
          ? e.id_commessa_distinta_base
          : e.id_rif;
        if (e.children && e.children.length > 0) {
          this.ids.push(e.id_treeview);
          this.getIdsForTreeview(e.children);
        }
      });
    },
    setLQA(arg) {
      this.distintaBaseList[0].children.forEach((c) => {
        if (c.id == arg.id) {
          c.lqa = c.lqa == 0 ? 1 : 0;
        }
      });

      this.key_bottone_sotto_lotto = this.key_bottone_sotto_lotto === 0 ? 1 : 0;
    },
    setMaterialeSottoLotto(arg) {
      this.distintaBaseList[0].children.forEach((c) => {
        if (c.id !== arg.id) {
          c.materiale_sotto_lotto = 0;
        } else {
          c.materiale_sotto_lotto = c.materiale_sotto_lotto == 1 ? 0 : 1;
        }
      });

      this.key_bottone_sotto_lotto = this.key_bottone_sotto_lotto === 0 ? 1 : 0;
    },
    // Update single element
    chiudiGestisciDistAlt() {
      this.distinte_alternative_visible = false;
    },
    clickGestisciDistAlt() {
      if (this.CompleteData.commessa[0].flag_picking === 1) {
        this.$refs.SnackbarQV.print(
          "orange",
          "È già stata generata una lista di picking per questa commessa e la distinta base non può essere modificata."
        );
        return;
      }

      this.distinte_alternative_visible = true;
      this.key_distinta_base_alt = this.key_distinta_base_alt === 0 ? 1 : 0;
    },
    getModuliDrawer() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getvisibilitydistintaalternativa",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.result.length > 0) {
              this.distinta_base_versione = res.data.result[0].val_int;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    handleSelezionataDistinta(arg) {
      this.distinte_alternative_visible = false;
      this.$emit("selezionata_distinta", arg);
    },
    updateDistinta() {
      this.distintaBaseList[0].children.forEach((c) => {
        if (
          c.id_commessa_distinta_base ==
          this.selectedcomponent.id_commessa_distinta_base
        ) {
          this.$set(c, "quantita", this.selectedcomponent.quantita);
          this.$set(c, "note", this.selectedcomponent.note);
        }
      });

      this.dialogDistintaBase = false;
      this.$refs.SnackbarQV.print(
        "success",
        "Modifica effettuata con successo!"
      );
    },
    // getting value of child articolo
    getDetail(item) {
      this.dialogArticoloDettaglio = true;
      this.recursiveId = item.id;
    },
    // to close modal
    closedetailModal() {
      this.dialogArticoloDettaglio = false;
    },
    // Delete one element
    deleteFolder(item) {
      if (item.id_commessa_distinta_base > -1) {
        item.validita = 0;
        this.deletedDistinta.push(item);
        this.$emit("delDistinta", item);
      }
      const i = this.distintaBaseList[0].children.findIndex((it) => it == item);
      this.distintaBaseList[0].children.splice(i, 1);
    },
    // rendering showing icons
    hideIcons() {
      this.hideicons = false;
      this.on = false;
      // this.openAll = true;
      this.open = this.ids;
    },
    // rendering hide icons
    showIcons() {
      this.hideicons = true;
      this.openAll = false;
      this.open = [];
      this.on = true;
    },
    // converting articolo detail for distinta base
    updateItem(val) {
      this.selectedcomponent = JSON.parse(JSON.stringify(val));
      this.selectedcomponent.cod_articolo = val.name
        .split(" : ")[0]
        .split(" x ")[1];
      this.selectedcomponent.des_articolo = val.name.split(" : ")[1];
      this.items = [this.selectedcomponent];

      this.dialogDistintaBase = true;
      this.disablesearch = true;
    },
    // searching articles to add as childrens
    searchDistintaBase(evt) {
      evt.preventDefault();
      let getdistintabase = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo,
        },
      };

      this.overlay_componente = true;
      this.$store
        .dispatch("api", getdistintabase)
        .then((res) => {
          this.overlay_componente = false;
          if (res.status === 200) {
            this.items = new Array();
            if (res.data.lista.length === 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                "Nessun articolo corrisponde ai criteri di ricerca."
              );
              return;
            }

            /* Metto nella lista gli articoli che non hanno
             * l'id_articolo del mio prodotto finito e che
             * non corrispondono per id_articolo a nessuno
             * dei componenti di primo livello che ho già nella
             * distinta base.
             * La guardia per evitare i componenti già presenti in
             * distinta base è stata commentata il giorno 03/06/2025
             * (per esplicita richiesta di Alberto) perché Ferrara
             * Quarzi vuole poter aggiungere più volte lo stesso
             * componente mettendoci note diverse. */
            this.items = res.data.lista.filter(
              (e) => e.id_articolo != this.id_articolo /*&&
                this.distintaBaseList[0].children.find(
                  (c) => c.id_componente == e.id_articolo
                ) === undefined*/
            );

            this.items.map((el) => (el.quantita = 0));
            this.items.map((el) => (el.note = null));
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    // in order to open to modal
    showModal() {
      if (this.CompleteData.commessa[0].flag_picking === 1) {
        this.$refs.SnackbarQV.print(
          "orange",
          "È già stata generata una lista di picking per questa commessa e la distinta base non può essere modificata."
        );
        return;
      }

      this.dialog = true;
    },
    // Create distinta
    saveDistinta() {
      let filteredObject = [];
      this.items.map((el) => {
        if (el.quantita > 0) {
          filteredObject.push(el);
        }
      });

      if (filteredObject.length == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Almeno un componente deve essere in quantità maggiore di 0."
        );
        return;
      }

      /* Controllo che non ci siano già elementi
       * con le note ripetute rispetto alle attuali. */
      let chk_is_nota_ripetuta = false;
      let chk_is_nota_ripetuta_new_componente = false;
      let chk_is_componente_ripetuto = false;
      let chk_testo_nota = "";
      let chk_cod_componenti_ripetuti = "";
      this.cod_componente_ripetuto = "";

      this.distintaBaseList[0].children.forEach((c) => {
        filteredObject.forEach((o) => {
          if (c.note == o.note && c.id_componente == o.id_articolo) {
            chk_testo_nota = o.note;
            chk_is_nota_ripetuta = true;
          }

          if (c.note == o.note) {
            chk_testo_nota = o.note;
            chk_cod_componenti_ripetuti += `"${
              c.name.split(" x ")[1].split(" : ")[0]
            }", `;
            chk_is_nota_ripetuta_new_componente = true;
            this.testo_nota_ripetuta_new_componente = `La nota «${
              o.note
            }» risulta già presente per il componente ${(
              chk_cod_componenti_ripetuti + ":"
            ).replace(
              ", :",
              ""
            )}. Sei sicuro di voler aggiungere il componente "${
              o.cod_articolo
            }" con la stessa nota?`;
          }

          if (o.id_articolo == c.id_componente) {
            /* Aggiungo il codice del componente nella stringa
             * da stampare solo se non ci sta già dentro. */
            if (
              (" " + this.cod_componente_ripetuto).indexOf(
                ` "${o.cod_articolo}",`
              ) == -1
            ) {
              this.cod_componente_ripetuto += `"${o.cod_articolo}", `;
            }
            chk_is_componente_ripetuto = true;
          }
        });
      });

      // Se ci sono note ripetute fermo tutto.
      if (chk_is_nota_ripetuta == true) {
        this.$refs.SnackbarQV.print(
          "orange",
          `La nota «${chk_testo_nota}» è già presente fra i componenti della distinta base per questo articolo.`
        );
        return;
      }

      // Se la nota è uguale su un componente diverso, mi fermo e chiedo conferma.
      if (
        chk_is_nota_ripetuta_new_componente == true &&
        this.force_aggiunta_nota == false
      ) {
        this.dialog_conferma_aggiunta_nota = true;
        return;
      }

      // Se il componente è ripetuto, mi fermo e chiedo conferma.
      if (
        chk_is_componente_ripetuto == true &&
        this.force_aggiunta_componente == false
      ) {
        this.dialog_conferma_aggiunta_componente = true;
        return;
      }

      // Resetto la guardia di forzatura dell'aggiunta della nota se necessario.
      if (this.force_aggiunta_nota == true) {
        this.force_aggiunta_nota = false;
      }

      // Resetto la guardia di forzatura dell'aggiunta del componente se necessario.
      if (this.force_aggiunta_componente == true) {
        this.force_aggiunta_componente = false;
      }

      /* Calcolo l'id_commessa_distinta_base minimo fra quelli già aggiunti
       * per assegnarne uno diverso, prima del salvataggio della commessa intera,
       * in modo da poter eventualmente ancora modificare in modo efficiente i
       * componenti che ho aggiunto provvisoriamente. */
      let min_id = -1;
      this.distintaBaseList[0].children.forEach((c) => {
        if (c.id_commessa_distinta_base <= min_id) {
          min_id = c.id_commessa_distinta_base;
        }
      });

      let overlay_counter = filteredObject.length;
      if (overlay_counter > 0) {
        this.overlay = true;
      }

      // Aggiungo i componenti che non sono ancora in distinta base.
      filteredObject.forEach((el, idx) => {
        const id_tmp = min_id - idx - 1;

        let getdistintabase = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getarticolidistintabase",
            id_articolo: el.id_articolo,
            token: localStorage.getItem("user_token"),
          },
        };

        this.$store
          .dispatch("api", getdistintabase)
          .then((res) => {
            overlay_counter -= 1;
            if (overlay_counter <= 0) {
              this.overlay = false;
            }

            let getresult = res.data;
            getresult[0].id_commessa_distinta_base = id_tmp;
            getresult[0].id_treeview = id_tmp;
            getresult[0].id_commessa = -1;
            getresult[0].id_articolo = this.IdArticolo;
            getresult[0].id_componente = el.id_articolo;
            getresult[0].id = parseInt(getresult[0].id);
            getresult[0].id_articolo = this.IdArticolo;
            getresult[0].quantita = el.quantita;
            getresult[0].id_rif = 0;
            getresult[0].note = el.note;
            getresult[0].materiale_sotto_lotto = 0;
            getresult[0].validita = 1;
            getresult[0].name = `${getresult[0].cod_um} x ${el.cod_articolo} : ${el.des_articolo}`;
            if (getresult[0].children[0]) {
              getresult[0].children[0].id_rif = 1;
            }
            this.distintaBaseList[0].children.push(getresult[0]);
            this.$emit("update", this.distintaBaseList);
            this.snackbar = true;
            this.snackbar_text = "Modifica effettuata con successo!";
            this.color = "green darken-3";
            this.mainIcon = "mdi-check-circle";
          })
          .catch((err) => {
            overlay_counter -= 1;
            if (overlay_counter <= 0) {
              this.overlay = false;
            }

            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          });
      });
      this.getIdsForTreeview([this.distintaBaseList[0]]);
      this.open = this.ids;
      /*this.distintaBaseList.map((el) => {
        if (el.children && el.children.length > 0) {
          el.children.map((el) => {
            this.ids.push(el.id);
          });
        }
      });*/
      this.dialog = false;
      this.items = [];
      this.cod_articolo = "";
    },
    // closing modal
    hideModal() {
      this.dialog = false;
      this.disablesearch = false;
      this.cod_articolo = "";
      this.items = [];
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    /*
            Handles a change on the file upload
          */
  },
};
</script>
<style lang="scss">
.hideoverflow {
  overflow: hidden !important;
}
</style>
